const characterPixelWidths: Record<string, number> = {
  0: 9,
  1: 5,
  2: 9,
  3: 9,
  4: 10,
  5: 9,
  6: 10,
  7: 8,
  8: 9,
  9: 10,
  a: 9,
  b: 9,
  c: 9,
  d: 9,
  e: 8,
  f: 5,
  g: 9,
  h: 8,
  i: 4,
  j: 4,
  k: 8,
  l: 4,
  m: 13,
  n: 8,
  o: 9,
  p: 9,
  q: 9,
  r: 5,
  s: 7,
  t: 6,
  u: 8,
  v: 8,
  w: 12,
  x: 8,
  y: 8,
  z: 7,
  A: 10,
  B: 9,
  C: 11,
  D: 10,
  E: 9,
  F: 9,
  G: 11,
  H: 10,
  I: 4,
  J: 7,
  K: 10,
  L: 9,
  M: 12,
  N: 10,
  O: 12,
  P: 9,
  Q: 12,
  R: 9,
  S: 9,
  T: 9,
  U: 10,
  V: 10,
  W: 14,
  X: 10,
  Y: 9,
  Z: 9,
  ' ': 3,
  '.': 4,
  ',': 4,
  '-': 9,
  _: 10,
  ä: 9,
  ö: 9,
  ü: 8,
  ß: 9,
  Ä: 10,
  Ö: 12,
  Ü: 10,
};

export const characterToPixelDictionary = new Map(Object.entries(characterPixelWidths));
